import React, { Component, PropsWithChildren } from 'react';
import cn from 'classnames';
import TableHead from './TableHead';
import TableBody from './TableBody';
import TableRow from './TableRow';
import TableCol from './TableCol';
import TableMessage from './TableMessage';
import TablePrice from './TablePrice';

export type TableProps = PropsWithChildren<{
  defaultClassName?: string;
  className?: string;
}>;

export class Table extends Component<TableProps> {
  static defaultProps = {
    defaultClassName: 'cart-table',
  };

  static Head = TableHead;
  static Body = TableBody;
  static Row = TableRow;
  static Col = TableCol;
  static Message = TableMessage;
  static Price = TablePrice;

  render(): JSX.Element {
    const { defaultClassName, className, ...otherProps } = this.props;

    const tableClassName = cn({
      [defaultClassName]: !!defaultClassName,
      [className]: !!className,
    });

    return <table className={tableClassName} {...otherProps} />;
  }
}

export default Table;
